import { colors } from "../theme";

interface CubeProps {
  x: number;
  y: number;
  size?: number;
  isAwake: boolean;
  isActive: boolean;
  isDark: boolean;
}

export function Cube({ x, y, size, isAwake, isActive, isDark }: CubeProps) {
  const baseSize = size || 40;
  const halfSize = baseSize / 2;

  const getColors = () => {
    if (isActive) {
      return {
        top: colors.magenta,
        left: "#B8267A",
        right: "#9E1F68",
        glow: `0 0 30px ${colors.magenta}60, 0 0 60px ${colors.magenta}30`,
      };
    }
    if (isAwake) {
      return {
        top: isDark ? colors.cyan : colors.blue,
        left: isDark ? "#228B8B" : "#1F7ABD",
        right: isDark ? "#1A7373" : "#1968A3",
        glow: isDark
          ? `0 0 20px ${colors.cyan}40`
          : `0 0 15px ${colors.blue}30`,
      };
    }
    return {
      top: isDark ? colors.base02 : colors.base2,
      left: isDark ? "#052D38" : "#DDD7C3",
      right: isDark ? "#041F27" : "#CCC6B2",
      glow: "none",
    };
  };

  const cubeColors = getColors();

  return (
    <div
      className="absolute"
      style={{
        left: x,
        top: y,
        width: baseSize,
        height: baseSize,
        transform: "translate(-50%, -50%)",
        transition: "filter 2s ease",
        filter: isAwake || isActive ? "none" : "saturate(0.3) opacity(0.6)",
      }}
    >
      {/* Isometric cube using CSS */}
      <div
        className="relative w-full h-full"
        style={{
          transform: "rotateX(60deg) rotateZ(-45deg)",
          transformStyle: "preserve-3d",
        }}
      >
        {/* Top face */}
        <div
          className="absolute inset-0"
          style={{
            background: cubeColors.top,
            transform: `translateZ(${halfSize}px)`,
            boxShadow: cubeColors.glow,
            transition: "background 2s ease, box-shadow 0.3s ease",
          }}
        />
        {/* Front face */}
        <div
          className="absolute"
          style={{
            width: baseSize,
            height: baseSize,
            background: cubeColors.left,
            transform: `rotateX(-90deg) translateZ(${halfSize}px)`,
            transformOrigin: "bottom",
            transition: "background 2s ease",
          }}
        />
        {/* Right face */}
        <div
          className="absolute"
          style={{
            width: baseSize,
            height: baseSize,
            background: cubeColors.right,
            transform: `rotateY(90deg) translateZ(${halfSize}px)`,
            transformOrigin: "left",
            transition: "background 2s ease",
          }}
        />
      </div>
    </div>
  );
}
